import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Details.css';

const Details = () => {
    const [students, setStudents] = useState([]);
    // const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     axios.get('http://localhost:4010/app/getInvoice')
    //         .then(students => setStudents(students.data)
    //        ).catch(err => console.log(err)
    //        );
    // }, []);

    useEffect(() => {
        axios.get('https://finalbackend-project.onrender.com/app/getInvoice')
            .then((response) => {
                setStudents(response.data); // Update the state with the fetched data
            })
            .catch((error) => {
                console.error("Error fetching student data:", error); // Log the error
                alert("Failed to fetch student data. Please try again later."); // Show user-friendly message
            });
    }, []);
    

 
    // Function to delete a student record
 const deleteStudent = (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
        axios.delete(`https://finalbackend-project.onrender.com/app/Invoice/${id}`)
            .then(() => {
                setStudents(students.filter(student => student._id !== id)); // Update the list
                alert(`Student record deleted successfully.`);
            })
            .catch(error => {
                console.error("Error deleting record:", error);
                alert("Failed to delete the record. Please try again.");
            });
    }
};    


    // if (loading) {
    //     return <div className="loading">Loading student records...</div>;
    // }

    return (
        <div className="student-details">
            <h2>Students Registered Details</h2>
            {students.length === 0 ? (
                <p>No students registered yet.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th className='t1'>First Name</th>
                            <th className='t1'>Last Name</th>
                            <th className='t1'>Gender</th>
                            <th className='t1'>Age</th>
                            <th className='t1'>Date Of Birth    </th>
                            <th className='t1'>Mobile</th>
                            <th className='t1'>Email</th>
                            <th className='t1'>Course</th>
                            <th className='t1'>Batch</th>
                            <th className='t1'>Admission Date</th>
                            <th className='t1'>Fees</th>
                            <th className='t1'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.map((student, index) => (
                            <tr key={student._id }>
                                <td>{index + 1}</td>
                                <td>{student.firstName}</td>
                                <td>{student.lastName}</td>
                                <td>{student.gender}</td>
                                <td>{student.age}</td>
                                <td>{student.dateOfBirth}</td>
                                <td>{student.mobile}</td>
                                <td>{student.email}</td>
                                <td>{student.course}</td>
                                <td>{student.batch}</td>
                                <td>{student.admissionDate}</td>
                                <td>{student.fees}</td>
                                <td>
                                    <button
                                        className="delete-button"
                                        onClick={() => deleteStudent(student._id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Details;
